import work_with_us from '../pages/api/localData/WorkWithUs.json';
import BannerHero from '../components/organisms/bannerHero/BannerHero';
import classes from '../styles/Page.module.scss';
import TwoColumnCopyImage from '../components/organisms/twoColumnCopyImage/TwoColumnCopyImage';
import ThreeColumnIconGrid from '../components/organisms/threeColumnIconGrid/ThreeColumnIconGrid';
import Button from '../components/atoms/button/Button';

/**
 * Simfy Web Home Page
 *
 * @returns {JSX.Element}
 * @constructor
 */
const WorkWithUs = () => {
    const { banner_hero, our_culture, our_benefits, positions, position_cta } =
        work_with_us?.work_with_us;
    return (
        <div className={classes.oPage}>
            <BannerHero data={banner_hero} />
            <TwoColumnCopyImage data={our_culture} />
            <ThreeColumnIconGrid data={our_benefits} />
            <TwoColumnCopyImage data={positions} />
            <span className={`${classes.mCtaWrapper} mCtaWrapper`}>
                <Button data={position_cta} />
            </span>
        </div>
    );
};

export default WorkWithUs;
